const redirectArray = {
    450: null,
    451: null,
    452: null,
    453: null,
    455: null,
    456: null,
}

export default redirectArray;